module.exports = __webpack_public_path__ + "img/d8629560f8de50592d7d39385a4635e2.057f6063.png";